/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type MondayBatchJobStateJobStatus =
  (typeof MondayBatchJobStateJobStatus)[keyof typeof MondayBatchJobStateJobStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MondayBatchJobStateJobStatus = {
  FAILED: "FAILED",
  RUNNING: "RUNNING",
  SUCCESSFUL: "SUCCESSFUL",
} as const;
